<template>
  <div class="nft-description-wrapper">
    <div class="back-button">
      <img
        v-show="showBackButton"
        src="@/Common/Icons/BackButton.svg"
        @click="goBack()"
        alt="Back"
      />
    </div>
    <p class="nft-name">
      {{ nft.name }}
    </p>
    <!--    TODO: add checking for pooled-->
    <div class="nft-price-pool" v-if="nft.pooled">
      <p>Price</p>
      <p>Pool</p>
    </div>
    <!--    TODO: get data and replace it from pool-->
    <div class="nft-price-pool-value" v-if="nft.pooled">
      <p>3.2 INDX-PL-TKN <span>$115</span></p>
      <p>Pool-Name</p>
    </div>
    <div class="nft-description-text">
      {{ nft.description }}
    </div>
    <div class="nft-tags-share">
      <div class="nft-tags">
        <div v-for="(tag, index) in nft.tags" :key="index" class="nft-tag">
          {{ tag }}
        </div>
      </div>
      <div class="share-nft-button-wrapper">
        <app-button
          buttonClass="share-nft-button"
          @click="toggleShare()"
        ></app-button>
        <img src="@/Common/Icons/share.png" alt="Share" />
        <div class="share-popup" v-if="showShare">
          <teleport to="body">
            <div class="share-popup-overlay" @click="toggleShare()"></div>
          </teleport>
          <p class="share-popup-text">Share this NFT</p>
          <div class="social-icons">
            <ShareNetwork
              v-for="network in networks"
              :network="network.network"
              :key="network.network"
              :url="`${url}/nft-details/${$route.params.id}`"
              :title="sharing.title"
              :description="sharing.description"
              :quote="sharing.quote"
              :hashtags="sharing.hashtags"
              :twitterUser="sharing.twitterUser"
              @click="analytics(network.name)"
            >
              <span class="icon-for-share"
                ><img
                  :src="network.icon"
                  :alt="network.name"
                  @mouseover="network.icon = network.lightIcon"
                  @mouseleave="network.icon = network.darkIcon"
              /></span>
            </ShareNetwork>
            <span
              ><img
                class="copy-link"
                :src="copyImg"
                @mouseover="copyImg = require('@/Common/Icons/CopyLight.svg')"
                @mouseleave="copyImg = require('@/Common/Icons/CopyDark.svg')"
                alt="Share"
                @click="
                  copyToClipboard(`${url}/nft-details/${$route.params.id}`)
                "
            /></span>
          </div>
        </div>
      </div>
    </div>
    <div class="nft-details-section">
      <div class="creator-owner-section">
        <div class="creator-owner-card">
          <p class="creator-owner-label">Creator</p>
          <div class="creator-owner-image">
            <img :src="avatarImage(nft.creator)" alt="CreatorImage" />
            <p class="name">{{ nft.creator.displayName }}</p>
          </div>
        </div>
        <div
          class="creator-owner-card"
          v-if="nft.owners && nft.owners.length > 0"
        >
          <p class="creator-owner-label">Owner</p>
          <div class="creator-owner-image">
            <img
              :src="avatarImage(nft.owners[nft.owners.length - 1])"
              alt="OwnerImage"
            />
            <p class="name">
              {{ nft.owners[nft.owners.length - 1].displayName }}
            </p>
          </div>
        </div>
      </div>
      <div>
        <p class="nft-label-text">
          Royalties:
          <span class="nft-royalties-percentage"
            >{{ nft.royaltyPercentage }}%</span
          >
        </p>
        <div class="royalties-info">
          <img
            class="royalties-icon royalties-img"
            src="@/Common/Icons/InfoRoyaltiesIcon.png"
          />
          <div class="royalties-hover">
            Percentage of each sell that the<br />
            creator will receive.
          </div>
        </div>
      </div>
    </div>
    <div class="nft-contract-address">
      <span class="nft-label-text">Contract address</span>
      <div>
        <img
          class="nft-contract-address-icon address-img"
          src="@/Common/Icons/CopyAddress.png"
          alt="Copy"
          @click="copyToClipboard(nft.contractAddress)"
        />
        <div class="info-hover address-hover">Copy address</div>
        <p class="nft-contract-address-text">
          {{ shortenedContractAddress() }}
        </p>
      </div>
    </div>
    <!--    TODO: add actions on buttons-->
    <!--    TODO: currently this button is removed-->
    <!--    <div class="nft-buttons" v-if="isUserCreator()">-->
    <!--      <button class="app-modal-button-transparent" v-if="nft.pooled">-->
    <!--        Buy back from pool-->
    <!--      </button>-->
    <!--      <button class="app-modal-button-transparent" v-else>Go to Deposit</button>-->
    <!--    </div>-->
    <!--    <div v-else class="nft-buttons">-->
    <!--      <button-->
    <!--        class="app-modal-button-inverse"-->
    <!--        v-show="!insufficientFunds"-->
    <!--        @click="checkFunds()"-->
    <!--      >-->
    <!--        Buy for 3.2 $INDX-PL-TKN-->
    <!--      </button>-->
    <!--      <button class="nft-button-grey" v-show="insufficientFunds">-->
    <!--        Insufficient $INDX-PL-TKN-->
    <!--      </button>-->
    <!--      <button class="app-modal-button-transparent" v-show="insufficientFunds">-->
    <!--        Buy $INDX-PL-TKN on Sushiswap-->
    <!--      </button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { useStore } from "vuex";
import useNftDetails from "@/composables/useNftDetails";
import useUtilities from "@/composables/useUtilities";
import imageTransformer from "@/plugins/imageTransformer";
import AppButton from "@/elements/AppButton";
import { useMeta } from "vue-meta";
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import useGoogleTag from "@/composables/useGoogleTag";

export default {
  components: {
    AppButton,
  },
  props: {
    nft: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const store = useStore();
    const { registerEvent } = useGoogleTag();
    const url = ref(process.env.VUE_APP_BASE_PATH);
    const router = useRouter();
    const { copyToClipboard } = useUtilities();
    const { shortenedContractAddress, isUserCreator } = useNftDetails(store);
    const avatarImage = (user) =>
      user.avatarFileName?.filename
        ? imageTransformer.transform(
            user.avatarFileName.filename,
            "user.avatar"
          )
        : require("@/Common/Icons/Avatar.png");
    let insufficientFunds = ref(false);

    // TODO: implement method
    const checkFunds = () => {
      insufficientFunds.value = true;
    };
    const showShare = ref(false);
    const toggleShare = () => (showShare.value = !showShare.value);
    const sharing = ref({
      title: "I've just minted an NFT through Theos",
      description: "",
      quote: "",
      hashtags: "theos",
      twitterUser: "theosfi",
    });
    const goBack = () => {
      store.dispatch("nftDetails/resetState");
      router.go(-1);
    };
    const showBackButton = computed(() => window.history.state.back !== null);
    const networks = ref([
      {
        network: "twitter",
        name: "Twitter",
        icon: require(`@/Common/Icons/twitterDark.svg`),
        darkIcon: require(`@/Common/Icons/twitterDark.svg`),
        lightIcon: require(`@/Common/Icons/twitterLight.svg`),
      },
      {
        network: "telegram",
        name: "Telegram",
        icon: require(`@/Common/Icons/telegramDark.svg`),
        darkIcon: require(`@/Common/Icons/telegramDark.svg`),
        lightIcon: require(`@/Common/Icons/telegramLight.svg`),
      },
      {
        network: "reddit",
        name: "Reddit",
        icon: require(`@/Common/Icons/RedditDark.svg`),
        darkIcon: require(`@/Common/Icons/RedditDark.svg`),
        lightIcon: require(`@/Common/Icons/RedditLight.svg`),
      },
      {
        network: "facebook",
        name: "Facebook",
        icon: require(`@/Common/Icons/facebookDark.svg`),
        darkIcon: require(`@/Common/Icons/facebookDark.svg`),
        lightIcon: require(`@/Common/Icons/facebookLight.svg`),
      },
    ]);
    const copyImg = ref(require("@/Common/Icons/CopyDark.svg"));
    useMeta(
      computed(() => ({
        title: `${props.nft.name} | THEOS`,
        description: props.nft.description,
        og: {
          title: `${props.nft.name}`,
          description: `${props.nft.description}`,
          image: [`${props.nft.coverImage.path}`],
          url: `${process.env.VUE_APP_BASE_PATH}/nft-details/${props.nft.id}`,
        },
      }))
    );

    const analytics = (name) => {
      registerEvent(`nft shared on ${name}`);
    };
    return {
      shortenedContractAddress,
      copyToClipboard,
      avatarImage,
      isUserCreator,
      insufficientFunds,
      checkFunds,
      toggleShare,
      showShare,
      networks,
      sharing,
      url,
      goBack,
      copyImg,
      showBackButton,
      analytics,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/nftDescription.scss"></style>
